<template>
    <div
        :class="{ 'l-ss-c-filter-is-short': isShort }"
        class="l-ss-c-filter-string">
        <c-label
            v-if="showTitle"
            :label="filterLabel"/>
    </div>
</template>

<script>
    import FilterMixin from './mixin';
    import CLabel from './components/label';

    export default {
        components: {
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
    };
</script>